import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import Money from 'components/Money'
import Text from 'components/Text'
import { Payment } from 'data/Payments/Payment/types'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'

import { Header, ModalTitle } from '../../styles'

const Button = styled(CeruleanButton)`
  margin-top: 24px;
  width: 100%;
`
const DepositText = styled(Text)`
  line-height: 150%;
`

const StyledHeader = styled(Header)`
  margin-bottom: 0;
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const ContentTopWrapper = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  gap: 1.5rem;
`

type SuccessProps = {
  deposit: Payment
  onClose?: () => void
}

const DepositPending = ({ deposit, onClose }: SuccessProps) => (
  <StyledWrapper>
    <ContentTopWrapper>
      <StyledHeader>
        <ModalTitle>
          <I18n data={messages.deposit_pending_title} />
        </ModalTitle>
      </StyledHeader>
      <DepositText color='grey600' size='16px'>
        <I18n
          amount={
            <b>
              <Money amount={deposit.amount.value} currency={deposit.amount.symbol} />
            </b>
          }
          data={messages.deposit_pending_description_ob_1}
        />
      </DepositText>
    </ContentTopWrapper>
    {onClose && (
      <footer>
        <Button onClick={onClose}>
          <I18n data={messages.button_ok} />
        </Button>
      </footer>
    )}
  </StyledWrapper>
)

export default DepositPending
